import { Alert, Modal, Row, Select, Space, Steps, Typography } from 'antd';
import { NumericalOutputConstraints } from './numerical-output-constraints'
import { CategoricalOutputConstraints } from '../categorical-output-constraints'
import Constraints from './Constraints'
import { useCallback, useEffect, useMemo, useState } from 'react'
import './input.scss'
import { useSelector } from 'react-redux'
import { StoreState } from 'src/store/configureStore'
import useTranslate from 'src/utils/useTranslate'
import { InverseConfigs } from '../InverseConfigs'
import { DeleteOutlined, ExclamationCircleOutlined, PlusOutlined, SettingOutlined } from '@ant-design/icons';
import { StyledButton } from 'src/styled_components/StyledButton';
import { antdTheme, AsyncStates } from 'src/constants';
import { IDataSheet } from 'src/components/IDataSheet';

const PayloadInput = ({
  modelData,
  addRow,
  disableCell,
  numericalObjectiveList,
  parameterListDropDown,
  setUnsavedChanges,
  numericalProperties,
  setRange,
  currentSelectedStage,
  isMultiStageModel,
  categoricalObjectiveList,
  categoricalRange,
  optionsDropDown,
  rangeParameterList,
  setRangeParameterList,
  catwiseRangeParameterList,
  setCatwiseRangeParameterList,
  categorialInputList,
  setCategorialInputList,
  activePredictionInputTab,
  setActivePredictionInputTab,
  selectedStages,
  catConstraintsList,
  setCatConstraintsList,
  setSelectAllIngredientsInCategory,
  selectAllIngredientsInCategory,
  setSelectAllProcessingInCategory,
  selectAllProcessingInCategory,
  exludeAllParameterConstraints,
  setExludeAllParameterConstraints,
  exludeAllCategoryConstraints,
  setExludeAllCategoryConstraints,
  isCrossCategorical,
  setIsCrossCategorical,
  setIsCrossCategoricalModalVisible,
  isCategoricalConstraintsUseDefault,
  setIsCategoricalConstraintsUseDefault,
  setInverseConfigurationData,
  inverseConfigurationData,
  validationsForSteps,
  configsOpenedViaPredictButton,
  generateExp,
  setConfigsOpenedViaPredictButton,
  includeMetadata,
  modelSelectionPropertiesData = [],
  setModelSelectionPropertiesData,
  defaultConstrainedApplied,
  setDefaultConstrainedApplied
}: any) => {
  const [t] = useTranslate()

  const [isCofigurationModalVisible, setIsCofigurationModalVisible] = useState(false)
  const [isModelSelectionModalVisible, setIsModelSelectionModalVisible] = useState(false)
  const [isModelSelectionEditing, setIsModelSelectionEditing] = useState(false)
  const [temporaryModelSelectionPropertiesData, setTemporaryModelSelectionPropertiesData] = useState([...modelSelectionPropertiesData])

  const onChange = useCallback((step: number) => {
    if (validationsForSteps()) {
      setActivePredictionInputTab((prev: any) => ({
        ...prev,
        [currentSelectedStage]: step
      }))
    }
  }, [currentSelectedStage, setActivePredictionInputTab, validationsForSteps])

  useEffect(() => {
    if (configsOpenedViaPredictButton) {
      setIsCofigurationModalVisible(true)
    }
  }, [configsOpenedViaPredictButton])

  const configs = useSelector((state: StoreState) => state.configs.features)

  // For the time being TODO : Remove after multistage objectives support
  useEffect(() => {
    if (currentSelectedStage !== selectedStages[1]) {
      if (activePredictionInputTab === 0 || !activePredictionInputTab?.[currentSelectedStage])
        setActivePredictionInputTab((prev: any) => ({
          ...prev,
          [currentSelectedStage]: 1
        }))
    }
  }, [
    activePredictionInputTab,
    currentSelectedStage,
    selectedStages,
    setActivePredictionInputTab,
  ])

  useEffect(() => {
    const collator = new Intl.Collator([], { numeric: true })

    const defaultConstraintsIngredients = Array.from(
      new Set(
        Object.values(modelData?.categories?.ingredients || {})
          ?.flatMap((i: any) => i)
          .sort(collator.compare),
      ),
    ).flatMap((category, catIndex) => [
      {
        constraint: "sum_of_category_quantity",
        type: "ingredients",
        category,
        min: null,
        max: null,
        catIndex,
      },
      {
        constraint: "count_of_category_items",
        type: "ingredients",
        category,
        min: null,
        max: null,
        catIndex,
      },
    ])
    const defaultConstraintsProcessing = Array.from(
      new Set(
        Object.values(modelData?.categories?.processing || {})?.flatMap(
          (i: any) => i,
        ),
      ),
    ).flatMap((category, catIndex) => [
      {
        constraint: "sum_of_category_quantity",
        type: "processing",
        category,
        min: null,
        max: null,
        catIndex,
      },
      {
        constraint: "count_of_category_items",
        type: "processing",
        category,
        min: null,
        max: null,
        catIndex,
      },
    ])
    const defaultCategoriesIngredients = (previousCategoriesData: any[]) => Array.from(
      new Set(
        Object.values(modelData?.categories?.ingredients || {})
          ?.flatMap((i: any) => i)
          .sort(collator.compare),
      ),
    ).map((category) => {
      const countMin = (
        category === "Reactants" ||
        category === "Solvents" ||
        previousCategoriesData?.find((prevCat: any) => prevCat.category === category)?.include)
        ? 1
        : !(Boolean(configs.nestle_configs) ? true : exludeAllCategoryConstraints?.["ingredients"]?.includes(category)) ? 0 : null

      // const sumMin = (
      //   category === "Reactants" || 
      //   category === "Solvents" || 
      //   previousCategoriesData?.find((prevCat: any) => prevCat.category === category)?.include) ||
      //   !(Boolean(configs.nestle_configs) ? true : exludeAllCategoryConstraints?.["ingredients"]?.includes(category)) 
      // ? 0 : null


      return {
        category,
        ...(category === "Reactants" || category === "Solvents"
          ? {
            exclude: false,
            include: true,
          }
          : {
            exclude: Boolean(configs.nestle_configs) ? true : exludeAllCategoryConstraints?.["ingredients"]?.includes(category) ?? false,
            include: previousCategoriesData?.find((prevCat: any) => prevCat.category === category)?.include ?? false,
          }),
        sum_of_category_quantity: {
          min: null,
          max: null
        },
        count_of_category_items: {
          min: countMin,
          max: null
        },
        item_constraints: {},
        parameter_constraints_categorical: [],
        type: "ingredients",
      }
    })
    const defaultCategoriesProcessing = Array.from(
      new Set(
        Object.values(modelData?.categories?.processing || {})
          ?.flatMap((i: any) => i)
          .sort(collator.compare),
      ),
    ).map((category) => ({
      category,
      exclude: false,
      include: true,
      sum_of_category_quantity: { min: null, max: null },
      count_of_category_items: { min: 1, max: null },
      item_constraints: {},
      parameter_constraints_categorical: [],
      type: "processing",
    }))
    setCatwiseRangeParameterList((state: any) => {
      const newState = JSON.parse(JSON.stringify(state))


      const defaultCategoriesIngredientsList = defaultCategoriesIngredients(newState?.[currentSelectedStage]?.[0]?.categories)

      defaultCategoriesIngredientsList.forEach((category: any) => {
        const catCountIndex = defaultConstraintsIngredients
          .findIndex((constraint: any) => constraint.category === category.category
            && constraint.type === "ingredients"
            && constraint.constraint === "count_of_category_items"
          )
        const catSumIndex = defaultConstraintsIngredients
          .findIndex((constraint: any) => constraint.category === category.category
            && constraint.type === "ingredients"
            && constraint.constraint === "sum_of_category_quantity"
          )
        if (catCountIndex >= 0) {
          defaultConstraintsIngredients[catCountIndex].min = category['count_of_category_items'].min
        }
        if (catSumIndex >= 0) {
          defaultConstraintsIngredients[catSumIndex].min = category['sum_of_category_quantity'].min
        }
      })

      defaultCategoriesProcessing.forEach((category: any) => {
        const catCountIndex = defaultConstraintsProcessing
          .findIndex((constraint: any) => constraint.category === category.category
            && constraint.type === "processing"
            && constraint.constraint === "count_of_category_items"
          )
        const catSumIndex = defaultConstraintsProcessing
          .findIndex((constraint: any) => constraint.category === category.category
            && constraint.type === "processing"
            && constraint.constraint === "sum_of_category_quantity"
          )
        if (catCountIndex >= 0) {
          defaultConstraintsProcessing[catCountIndex].min = category['count_of_category_items'].min
        }
        if (catSumIndex >= 0) {
          defaultConstraintsProcessing[catSumIndex].min = category['sum_of_category_quantity'].min
        }
      })


      newState[currentSelectedStage] = [
        {
          parameter_type: "ingredients",
          categories: defaultCategoriesIngredientsList,
        },
        {
          parameter_type: "processing",
          categories: defaultCategoriesProcessing,
        },
      ]
      return newState
    })

    setCatConstraintsList((prevState: any) => {
      const newState = JSON.parse(JSON.stringify(prevState))
      if (!newState.hasOwnProperty(String(currentSelectedStage)) || newState?.[currentSelectedStage]?.length <= 0) {
        newState[currentSelectedStage] = [
          ...defaultConstraintsIngredients,
          ...defaultConstraintsProcessing,
        ]
      }
      return newState
    })

    // Not including currentSelectedStage as modelData dependency covers it anyway and we don't want rerender
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    modelData,
    setCatwiseRangeParameterList,
    currentSelectedStage,
    configs.nestle_configs,
  ])

  const renderStepContent = useCallback(() => {
    if (activePredictionInputTab[currentSelectedStage] === 0) {
      return (
        <Space direction="vertical" size="large">
          {/* OUTPUT CONSTRAINTS */}
          <NumericalOutputConstraints
            addRow={addRow}
            disableCell={disableCell}
            numericalObjectiveList={numericalObjectiveList}
            parameterListDropDown={parameterListDropDown}
            setUnsavedChanges={setUnsavedChanges}
            numericalProperties={numericalProperties}
            setNumericalProperties={setRange}
            currentSelectedStage={currentSelectedStage}
            isMultiStage={isMultiStageModel}
          />

          {categoricalObjectiveList.length > 0 && (
            <CategoricalOutputConstraints
              addRow={addRow}
              categoricalObjectiveList={categoricalObjectiveList}
              categoricalRange={categoricalRange}
              optionsDropDown={optionsDropDown}
              parameterListDropDown={parameterListDropDown}
            />
          )}
        </Space>
      )

    }

    if (activePredictionInputTab[currentSelectedStage] === 1) {
      return (
        <Constraints
          parameterList={rangeParameterList}
          setParameterList={setRangeParameterList}
          catwiseParameterList={catwiseRangeParameterList}
          setCatwiseParameterList={setCatwiseRangeParameterList}
          modelData={modelData}
          setUnsavedChanges={setUnsavedChanges}
          categorialInputList={categorialInputList}
          setCategorialInputList={setCategorialInputList}
          range={numericalProperties}
          categoricalRange={categoricalRange}
          currentSelectedStage={currentSelectedStage}
          isMultiStage={isMultiStageModel}
          catConstraintsList={catConstraintsList}
          setCatConstraintsList={setCatConstraintsList}
          setSelectAllIngredientsInCategory={setSelectAllIngredientsInCategory}
          selectAllIngredientsInCategory={selectAllIngredientsInCategory}
          selectAllProcessingInCategory={selectAllProcessingInCategory}
          setSelectAllProcessingInCategory={setSelectAllProcessingInCategory}
          exludeAllParameterConstraints={exludeAllParameterConstraints}
          setExludeAllParameterConstraints={setExludeAllParameterConstraints}
          exludeAllCategoryConstraints={exludeAllCategoryConstraints}
          setExludeAllCategoryConstraints={setExludeAllCategoryConstraints}
          isCrossCategorical={isCrossCategorical}
          setIsCrossCategorical={setIsCrossCategorical}
          setIsCrossCategoricalModalVisible={setIsCrossCategoricalModalVisible}
          isCategoricalConstraintsUseDefault={isCategoricalConstraintsUseDefault}
          setIsCategoricalConstraintsUseDefault={setIsCategoricalConstraintsUseDefault}
          includeMetadata={includeMetadata}
          defaultConstrainedApplied={defaultConstrainedApplied}
          setDefaultConstrainedApplied={setDefaultConstrainedApplied}
        />
      )
    }

  }, [activePredictionInputTab, currentSelectedStage, addRow, disableCell, numericalObjectiveList, parameterListDropDown, setUnsavedChanges, numericalProperties, setRange, isMultiStageModel, categoricalObjectiveList, categoricalRange, optionsDropDown, rangeParameterList, setRangeParameterList, catwiseRangeParameterList, setCatwiseRangeParameterList, modelData, categorialInputList, setCategorialInputList, catConstraintsList, setCatConstraintsList, setSelectAllIngredientsInCategory, selectAllIngredientsInCategory, selectAllProcessingInCategory, setSelectAllProcessingInCategory, exludeAllParameterConstraints, setExludeAllParameterConstraints, exludeAllCategoryConstraints, setExludeAllCategoryConstraints, isCrossCategorical, setIsCrossCategorical, setIsCrossCategoricalModalVisible, isCategoricalConstraintsUseDefault, setIsCategoricalConstraintsUseDefault, includeMetadata, defaultConstrainedApplied, setDefaultConstrainedApplied])


  const defaultInverseConfigData = useSelector((state: StoreState) => state.inverseModel.inverseConfigData)

  const newInverseModel = useSelector(
    (state: StoreState) => state.newInverseModel
  )

  const filteredPropertyOptions = useMemo(() => {
    const selectedProperties = temporaryModelSelectionPropertiesData?.map((property: any) => property.property_id).filter((property: string) => property && property.length > 0) ?? []
    return Object.keys(modelData?.models_per_property ?? {}).filter((property) => !selectedProperties?.includes(property)).map((property: string) => ({
      label: modelData?.display_names?.properties?.[property] ?? property,
      value: property
    }))
  }, [modelData?.display_names?.properties, modelData?.models_per_property, temporaryModelSelectionPropertiesData])


  const dropdownSelectComponent = useCallback((property_index: number, option_type: "property_selection" | "model_selection") => {
    const property_id = temporaryModelSelectionPropertiesData?.[property_index]?.property_id
    const options = option_type === "model_selection" ? (modelData?.models_per_property?.[property_id] || []).map((model_name: string) => ({
      label: model_name,
      value: model_name
    })) : filteredPropertyOptions

    const value = option_type === "model_selection" ? temporaryModelSelectionPropertiesData?.[property_index]?.model_name : modelData?.display_names?.properties[temporaryModelSelectionPropertiesData?.[property_index]?.property_id]

    return <Select options={options}
      value={value}
      showSearch
      optionFilterProp='label'
      style={{ width: "100%" }}
      placeholder={t("common.select")}
      onChange={(value: string) => {
        setIsModelSelectionEditing(true)
        if (option_type === "model_selection") {
          setTemporaryModelSelectionPropertiesData((prev: any) => {
            const newState = JSON.parse(JSON.stringify(prev ?? [])) ?? []
            const errors = (newState[property_index]?.errors ?? []).filter((error: string) => error !== "model_name")

            newState[property_index] = {
              ...newState[property_index],
              model_name: value,
              errors: errors,
              isSaved: false
            }
            return newState
          })
        } else if (option_type === "property_selection") {
          setTemporaryModelSelectionPropertiesData((prev: any) => {
            const newState = JSON.parse(JSON.stringify(prev ?? {})) ?? {}
            const errors = (newState[property_index]?.errors ?? []).filter((error: string) => error !== "property_id")
            newState[property_index] = {
              property_id: value,
              model_name: null,
              errors: errors,
              isSaved: false
            }
            return newState
          })
        }
      }}
    />
  }, [temporaryModelSelectionPropertiesData, modelData?.models_per_property, modelData?.display_names?.properties, filteredPropertyOptions, t])

  const modelSelectiondatasheetData = useMemo(() => {
    return [
      [
        {
          value: t("common.property"),
          component: (
            <Row>
              <Typography.Text strong>
                {t("common.property")}
              </Typography.Text>
            </Row>
          ),
          forceComponent: true,
          readOnly: true,
          width: "250px",
          fixed: true

        },
        {
          value: "Model Selection",
          component: (
            <Row>
              <Typography.Text strong>
                {t("common.modelSelection")}
              </Typography.Text>
            </Row>
          ),
          readOnly: true,
          forceComponent: true,
          width: "200px",
          fixed: true
        },
      ],
      ...temporaryModelSelectionPropertiesData?.map((property: any, property_index: number) => {
        return [
          {
            value: property.property_id || "",
            className: "dropdown-remove-cell",
            component: <>
              <div style={{
                display: "flex",
                alignItems: "center",
                gap: "0.5rem"
              }} key={property.property_id}>
                <div>
                  <DeleteOutlined
                    style={{ color: "red", cursor: "pointer" }}
                    onClick={() => {
                      setIsModelSelectionEditing(true)
                      setTemporaryModelSelectionPropertiesData((prev: any) => {
                        const newState = JSON.parse(JSON.stringify(prev ?? [])) ?? []
                        let updatedState = newState.filter((_: any, index: number) => index !== property_index)
                        return updatedState
                      })
                    }}
                  />
                </div>
                <div
                  style={{ width: "100%" }}
                >
                  <div>
                    {dropdownSelectComponent(property_index, "property_selection")}
                  </div>
                  {
                    property?.errors?.includes("property_id") &&
                    <span
                      style={{
                        color: "#ff4d4f"
                      }}
                    >{t("common.requiredInfo")}
                    </span>
                  }
                </div>
              </div>
            </>,
            width: "250px",
            forceComponent: true,
          },
          {
            value: property?.model_name || "",
            component: <div style={{
              display: "flex",
              flexDirection: "column"
            }}>{dropdownSelectComponent(property_index, "model_selection")}
              {
                property?.errors?.includes("model_name") &&
                <span
                  style={{
                    color: "#ff4d4f"
                  }}
                >{t("common.requiredInfo")}
                </span>
              }
            </div>,
            width: "200px",
            forceComponent: true,
          }
        ]
      })
    ]
  }, [dropdownSelectComponent, t, temporaryModelSelectionPropertiesData])


  const handleClose = () => {
    setIsModelSelectionEditing(false)
    setIsModelSelectionModalVisible(false)
    setModelSelectionPropertiesData((prev: any) => {
      const newState = JSON.parse(JSON.stringify(prev ?? {})) ?? {}
      newState[currentSelectedStage] = temporaryModelSelectionPropertiesData?.filter((propertyData: any) => !!propertyData?.isSaved && !!propertyData?.model_name?.length && !!propertyData?.model_name?.length)?.map((propertyData: any) => ({
        ...propertyData,
        errors: []
      }))
      return newState
    })
  }

  const handleCloseModal = () => {
    const isNotSaved = temporaryModelSelectionPropertiesData.some((propertyData: any) => !propertyData?.isSaved || !!propertyData?.errors?.length)
    if (isNotSaved || isModelSelectionEditing) {
      Modal.confirm({
        title: `${t("common.unsavedChangesPresent")}`,
        icon: <ExclamationCircleOutlined />,
        okText: `${t("common.ok")}`,
        onOk: () => {
          setIsModelSelectionEditing(false)
          setIsModelSelectionModalVisible(false)
        }
      })
    } else {
      handleClose()
    }
  }


  return (
    <div style={{
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: "2rem",
    }} >
      <Space style={{
        justifyContent: "space-between",
        width: "100%",
        alignItems: "center"
      }} >
        <Steps
          current={activePredictionInputTab[currentSelectedStage]}
          onChange={onChange}
          items={[
            {
              title: `${t("common.objectives")}`,
              style: { display: !(currentSelectedStage === selectedStages[1]) ? 'none' : "flex" }
            },
            {
              title: `${t("common.constraints")}`,
            },
          ]}

        />
        <div
          style={{
            display: "flex",
            gap: "0.5rem",
            alignItems: "center",
          }}
        >
          <StyledButton
            type="default"
            size="small"
            style={{ borderRadius: 5, outline: "none" }}
            disabled={!Object.keys(modelData?.models_per_property ?? {}).length}
            onClick={() => {
              if (!modelSelectionPropertiesData?.length) {
                setTemporaryModelSelectionPropertiesData((prev: any) => {
                  return [{
                    property_id: "",
                    model_name: "",
                    errors: [],
                    isSaved: true
                  }]
                })
              } else {
                setTemporaryModelSelectionPropertiesData(modelSelectionPropertiesData)
              }
              setIsModelSelectionModalVisible(true)
            }}
          >
            {t("common.propertiesModelSelection")}
          </StyledButton>
          {currentSelectedStage === selectedStages[1] && <StyledButton
            icon={<SettingOutlined />}
            type="default"
            size="small"
            style={{ borderRadius: 5, outline: "none" }}
            onClick={() => setIsCofigurationModalVisible(true)}
          >
            {t("aiEngine.configurations")}
          </StyledButton>}
        </div>
      </Space>
      {renderStepContent()}

      <Modal
        title={<Space direction='vertical' >
          <Typography.Title level={4}>
            {t("aiEngine.configurations")}
          </Typography.Title>
          <Typography.Text type={'secondary'} style={{
            fontSize: antdTheme.fontSizeSM
          }}>
            {t('aiEngine.inverseConfigs.note')}
          </Typography.Text>
        </Space>}
        open={isCofigurationModalVisible}
        onCancel={() => {
          setIsCofigurationModalVisible(false)
          if (configsOpenedViaPredictButton) {
            setConfigsOpenedViaPredictButton(false)
          }
        }}
        closable
        width={800}
        footer={
          <Space style={{
            justifyContent: "flex-end"
          }} >
            <StyledButton
              onClick={() => {
                setInverseConfigurationData((prev: any) => {
                  const newState = JSON.parse(JSON.stringify(prev ?? {})) ?? {}
                  return {
                    ...newState,
                    [currentSelectedStage]: JSON.parse(JSON.stringify(defaultInverseConfigData ?? {}))
                  }
                })
              }}
              type='default'
            >
              {t("common.reset")}
            </StyledButton>
            {configsOpenedViaPredictButton ?
              <StyledButton
                loading={newInverseModel.inverseStatus === AsyncStates.LOADING}
                type="primary"
                onClick={() => {
                  if (validationsForSteps()) {
                    setUnsavedChanges(false)
                    generateExp('range')
                    setIsCofigurationModalVisible(false)
                    setConfigsOpenedViaPredictButton(false)
                  }
                }}
                style={{ outline: 'none' }}
              >
                {newInverseModel.inverseStatus === AsyncStates.LOADING ? t('aiEngine.predicting') : t('aiEngine.inverseModel.predictExperiments')}
              </StyledButton> :
              <StyledButton
                onClick={() => {
                  setIsCofigurationModalVisible(false)
                  if (configsOpenedViaPredictButton) {
                    setConfigsOpenedViaPredictButton(false)
                  }
                }}
                type='primary'
              >
                {t("common.continue")}
              </StyledButton>
            }
          </Space>
        }
      >
        <InverseConfigs
          currentSelectedStage={currentSelectedStage}
          fromPredictButton={configsOpenedViaPredictButton}
          inverseConfigurationData={inverseConfigurationData?.[currentSelectedStage] ?? {}}
          setInverseConfigurationData={setInverseConfigurationData}
        />
      </Modal>


      <Modal
        title={t("common.modelSelectionForProperties")}
        open={isModelSelectionModalVisible}
        width={800}
        footer={null}
        maskClosable={false}
        onCancel={() => {
          handleCloseModal()
        }}
      >
        <div style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem"
        }}>
          <div style={{
            display: "flex",
            gap: "1rem",
            justifyContent: "space-between",
            alignItems: "center",
          }}>
            <div>
              <Alert type='info' showIcon message={t("aiEngine.modelSelection.defaultModelNote")} />
            </div>
            <div>
              <StyledButton
                type="default"
                size="small"
                icon={<PlusOutlined />}
                style={{ borderRadius: 5, outline: "none" }}
                disabled={!filteredPropertyOptions.length || temporaryModelSelectionPropertiesData?.length >= Object.keys(modelData?.models_per_property ?? {}).length}
                onClick={() => {
                  setIsModelSelectionEditing(true)
                  setTemporaryModelSelectionPropertiesData((prev: any) => {
                    const newState = JSON.parse(JSON.stringify(prev ?? [])) ?? []
                    return [
                      ...(newState || []),
                      {
                        property_id: "",
                        model_name: "",
                        errors: [],
                        isSaved: false
                      }
                    ]
                  })
                }}
              >{t("inventory.AddProperties")}</StyledButton>
            </div>
          </div>

          <div style={{
            flex: 1,
            overflowY: "auto",
            maxHeight: "400px",
          }}>
            <IDataSheet
              data={modelSelectiondatasheetData}
              valueRenderer={(cell) => cell.value}
              className='model-selection-datasheet'
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "0.5rem"
            }}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "0.5rem",
                alignItems: "center"
              }}
            >
              <StyledButton
                onClick={() => {
                  const version = modelData?.version
                  const url = `/model-details?version=${version}`;
                  window.open(url, '_blank', 'noopener,noreferrer');
                }}
              >
                {t("aiEngine.viewModelDetails")}
              </StyledButton>
            </div>

            <div
              style={{
                display: "flex",
                gap: "0.5rem"
              }}
            >
              <StyledButton onClick={() => handleCloseModal()}>
                {t(("common.cancel"))}
              </StyledButton>
              <StyledButton type='primary' onClick={() => {
                const dataMap = temporaryModelSelectionPropertiesData.map((propertyData: any) => {
                  const errors = [];
                  if (!propertyData?.property_id) errors.push("property_id");
                  if (!propertyData?.model_name) errors.push("model_name");

                  return {
                    ...propertyData,
                    isSaved: errors.length === 0,
                    errors
                  };
                });


                const errorFound = dataMap.some((propertyData: any) => !!propertyData?.errors?.length)



                setTemporaryModelSelectionPropertiesData(dataMap)

                if (!errorFound) {
                  setModelSelectionPropertiesData((prev: any) => {
                    const newState = JSON.parse(JSON.stringify(prev ?? {})) ?? {}
                    newState[currentSelectedStage] = [...dataMap]
                    return newState
                  })
                  setIsModelSelectionEditing(false)
                  setIsModelSelectionModalVisible(false)
                }
              }}>
                {t(("common.save"))}
              </StyledButton>
            </div>
          </div>
        </div>

      </Modal >
    </div >

  )
}

export default PayloadInput